import { useEffect } from "react";

const EVENT = "Event";
const LABEL_SEPARATOR = "\u2022";

const POLICY_CATEGORY = "Policy";
const SEARCH_CATEGORY = "Searches";
const POLICY_ACTIONS = {
  DOWNLOAD_TO_WORD: "Download To Word",
  EDIT: "Edit",
  EMAIL: "Email",
  PRINT: "Print",
  VIEW: "View"
};
const SEARCH_ACTION = "PSA Search";
const QUICK_SEARCH_ACTION = "Quick Search";
const SEARCH_SELECTION_ACTION = "Search Selection";

const triggerEvent = (category, action, label) => {
  if (window.googleTagData) {
    window.googleTagData.push({
      event: EVENT,
      eventProps: {
        category: category,
        action: action,
        label: label
      }
    });
  }
};

const getPolicyEventLabel = (title, category, pk) =>
  `${title}${LABEL_SEPARATOR}${category}${LABEL_SEPARATOR}${pk}`;

export const triggerQuickSearchEvent = (
  suggestedSearchQuery,
  suggestedSearchDocumentPk,
  suggestedSearchTitleClicked,
  suggestedSearchCategoryClicked,
  suggestedSearchResultNumber
) => {
  const label = `${LABEL_SEPARATOR}${suggestedSearchQuery}${LABEL_SEPARATOR}${suggestedSearchDocumentPk}${LABEL_SEPARATOR}${suggestedSearchTitleClicked}${LABEL_SEPARATOR}${suggestedSearchCategoryClicked}${LABEL_SEPARATOR}${suggestedSearchResultNumber}`;
  triggerEvent(SEARCH_CATEGORY, QUICK_SEARCH_ACTION, label);
};

export const triggerPolicyDownloadToWordEvent = (title, category, pk) => {
  const label = getPolicyEventLabel(title, category, pk);
  triggerEvent(POLICY_CATEGORY, POLICY_ACTIONS.DOWNLOAD_TO_WORD, label);
};

export const triggerPolicyEditEvent = (title, category, pk) => {
  const label = getPolicyEventLabel(title, category, pk);
  triggerEvent(POLICY_CATEGORY, POLICY_ACTIONS.EDIT, label);
};

export const triggerPolicyEmailEvent = (title, category, pk) => {
  const label = getPolicyEventLabel(title, category, pk);
  triggerEvent(POLICY_CATEGORY, POLICY_ACTIONS.EMAIL, label);
};

export const triggerPolicyPrintEvent = (title, category, pk) => {
  const label = getPolicyEventLabel(title, category, pk);
  triggerEvent(POLICY_CATEGORY, POLICY_ACTIONS.PRINT, label);
};

export const triggerSearchEvent = (totalCount, queryString) => {
  const label = `${LABEL_SEPARATOR}${totalCount}${LABEL_SEPARATOR}${queryString}`;
  triggerEvent(SEARCH_CATEGORY, SEARCH_ACTION, label);
};

export const triggerSearchSelectionEvent = (
  searchQuery,
  documentUrl,
  documentName,
  resultNumber,
  categoryName,
  numberOfResults
) => {
  const label = `${LABEL_SEPARATOR}${searchQuery}${LABEL_SEPARATOR}${documentUrl}${LABEL_SEPARATOR}${documentName}${LABEL_SEPARATOR}${resultNumber}${LABEL_SEPARATOR}${categoryName}${LABEL_SEPARATOR}${numberOfResults}`;
  triggerEvent(SEARCH_CATEGORY, SEARCH_SELECTION_ACTION, label);
};

export const triggerPolicyViewEvent = (title, category, pk) => {
  const label = getPolicyEventLabel(title, category, pk);
  triggerEvent(POLICY_CATEGORY, POLICY_ACTIONS.VIEW, label);
};

export const TriggerEventOnMount = ({ triggerEvent, children }) => {
  // only call triggerEvent on component mount so we don't get duplicate events on re-renders
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => triggerEvent(), []);
  return children;
};
